import { render } from "./TaskViewDetalleGenerico.vue?vue&type=template&id=da8b8126"
import script from "./TaskViewDetalleGenerico.vue?vue&type=script&lang=js"
export * from "./TaskViewDetalleGenerico.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__